module.exports = __webpack_public_path__ + "img/light-bulb.57320ae4.svg";